import { Classes } from '@blueprintjs/core';
import { THEME } from 'app/theme/theme';
import { DataAttributeProps } from 'app/types';
import { NoiseClassificationIconMap } from 'app/views/configuration/pages/noise/noise-classifications/noise-classification-icon';
import { ChangeEvent } from 'react';
import {
  SelectableButtonIcon,
  SelectableButtonInner,
  SelectableButtonInput,
  SelectableButtonText,
  SelectableButtonWrapper,
} from './SelectableButton.styles';

type SelectableButtonProps = {
  name: string;
  disabled?: boolean;
  isSelected?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  isLoading?: boolean;
  icon?: keyof typeof NoiseClassificationIconMap;
  background?: string;
  textColor?: string;
  buttonInnerProps?: React.HTMLAttributes<HTMLSpanElement> & DataAttributeProps;
  highlightSelected?: boolean;
};

export const SelectableButton = ({
  name,
  isSelected,
  isLoading = false,
  icon,
  onChange,
  disabled = false,
  background = THEME.colors.brand.brand01,
  textColor,
  buttonInnerProps,
  highlightSelected = false,
}: SelectableButtonProps) => {
  return (
    <SelectableButtonWrapper $isLoading={isLoading} data-testid="selectable-button">
      <SelectableButtonInput
        checked={isSelected}
        disabled={isLoading || disabled}
        onChange={onChange}
        $highlightSelected={highlightSelected}
      />
      <SelectableButtonInner
        className={isLoading ? Classes.SKELETON : undefined}
        $background={background}
        $textColor={textColor}
        $isSelected={isSelected}
        {...buttonInnerProps}
      >
        {!!icon && <SelectableButtonIcon icon={icon} />}
        <SelectableButtonText>{name}</SelectableButtonText>
      </SelectableButtonInner>
    </SelectableButtonWrapper>
  );
};
